// import { createApp } from 'vue'
// import App from './App.vue'
import buildApp from "./app";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueTippy from "vue-tippy";
import "tippy.js/dist/tippy.css"; // Tippy.js styles

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import 'vue-final-modal/style.css'

const { app, router } = buildApp();

// Disable all warnings
// app.config.warnHandler = () => {};

app.use(Toast, {
  position: POSITION.BOTTOM_RIGHT,
});

app.use(VueTippy);

router.isReady().then(() => {
  app.mount("#app", true);
});
